module.exports = "../images/2.jpg?c89be4dd25168c69728337fee216e02d";